import React from 'react';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

const LoadingSpinner = ({ isLoading, overlayWidth, overlayHeight }) => {
  return (
    <div style={{ position: 'relative' }}>
      <div
        className="loading-overlay"
        style={{
          width: overlayWidth,
          height: overlayHeight,
          opacity: isLoading ? '1' : '0',
        }}
      >
        <img
          className="spinner"
          src="https://pub-3ff0bf4b9e934ca3ae258ae98e7eefd1.r2.dev/orsan-isotipo.webp"
          alt="Loading..."
        />
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  overlayWidth: PropTypes.string,
  overlayHeight: PropTypes.string,
};
LoadingSpinner.defaultProps = {
  overlayWidth: '100%',
  overlayHeight: '100%',
};
export default LoadingSpinner;
